<template>
    <BorrarModalComponent
        :name="'borrar-sesion-' + sesion.id"
        title="¿Seguro que quieres borrar esta sesion?"
        borrarTitle="Datos de la sesión"
        confirmButton="¿BORRAR SESIÓN?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarSesion()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Fecha:</b> {{ sesion.fecha }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>

    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['evento', 'sesion'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-sesion-' + this.sesion.id, borrado);
            },
            borrarSesion() {
                const params = {
                    filters : {},
                    evento_id: this.evento.id,
                    sesion_id: this.sesion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
